import { createRouter, createWebHistory } from "vue-router";
import DashboardView from "@/views/DashboardView.vue";
import CallbackView from "@/views/CallbackView.vue";
import ProfileView from "@/views/ProfileView.vue";
import SettingsView from "@/views/SettingsView.vue";
import CountriesRiskView from "@/views/CountriesRiskView.vue";
import OrganizationDocumentsView from "@/views/OrganizationDocumentsView.vue";
import CustomersView from "@/views/CustomersView.vue";
import CustomersOverview from "@/views/customers/CustomersOverview.vue";
import NewCompanyView from "@/views/customers/companies/NewCompanyView.vue";
import CompanyView from "@/views/customers/companies/CompanyView.vue";
import NewPhysicalPersonView from "@/views/customers/physical-persons/NewPhysicalPersonView.vue";
import EditCompanyView from "@/views/customers/companies/EditCompanyView.vue";
import EditPhysicalPersonView from "@/views/customers/physical-persons/EditPhysicalPersonView.vue";
import PhysicalPersonView from "@/views/customers/physical-persons/PhysicalPersonView.vue";
import SaleListingAgreementsOverviewView from "@/views/sale-listing-agreements/SaleListingAgreementsOverviewView.vue";
import NewSaleListingAgreement from "@/views/sale-listing-agreements/NewSaleListingAgreementView.vue";
import EditSaleListingAgreement from "@/views/sale-listing-agreements/EditSaleListingAgreementView.vue";
import { authGuard } from "@auth0/auth0-vue";
import SaleListingAgreementView from "@/views/sale-listing-agreements/SaleListingAgreementView.vue";
import SaleListingAgreementRiskProfileView from "@/views/sale-listing-agreements/SaleListingAgreementRiskProfileView.vue";
import NewPurchaseOfferView from "@/views/pruchase-offers/NewPurchaseOfferView.vue";
import SaleListingAgreementsView from "@/views/SaleListingAgreementsView.vue";
import PurchaseOffersView from "@/views/PurchaseOffersView.vue";
import PurchaseAgreementsView from "@/views/PurchaseAgreementsView.vue";
import NewPurchaseAgreementView from "@/views/pruchase-agreements/NewPurchaseAgreementView.vue";
import EditPurchaseAgreementView from "@/views/pruchase-agreements/EditPurchaseAgreementView.vue";
import EditPurchaseOfferView from "@/views/pruchase-offers/EditPurchaseOfferView.vue";
import NewRentalListingAgreementView from "@/views/rental-listing-agreements/NewRentalListingAgreementView.vue";
import EditRentalListingAgreementView from "@/views/rental-listing-agreements/EditRentalListingAgreementView.vue";
import RentalListingAgreementsOverviewView from "@/views/rental-listing-agreements/RentalListingAgreementsOverviewView.vue";
import RentalListingAgreementView from "@/views/rental-listing-agreements/RentalListingAgreementView.vue";
import RentalListingAgreementsView from "@/views/RentalListingAgreementsView.vue";
import RentalListingAgreementRiskProfileView from "@/views/rental-listing-agreements/RentalListingAgreementRiskProfileView.vue";
import LeaseAgreementsView from "@/views/LeaseAgreementsView.vue";
import NewLeaseAgreementView from "@/views/lease-agreements/NewLeaseAgreementView.vue";
import EditLeaseAgreementView from "@/views/lease-agreements/EditLeaseAgreementView.vue";
import FaqView from "@/views/FaqView.vue";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      name: "home",
      component: DashboardView,
      beforeEnter: authGuard,
      meta: { breadcrumb: "Acceuil" },
    },
    {
      path: "/profile",
      name: "profile",
      component: ProfileView,
      beforeEnter: authGuard,
      meta: { breadcrumb: "Profil" },
    },
    {
      path: "/faq",
      name: "faq",
      component: FaqView,
      beforeEnter: authGuard,
      meta: { breadcrumb: "Faq" },
    },
    {
      path: "/customers",
      name: "customers",
      component: CustomersView,
      beforeEnter: authGuard,
      meta: { breadcrumb: "Clients", icon: "UsersIcon" },
      children: [
        {
          path: "",
          name: "customers-overview",
          component: CustomersOverview,
          beforeEnter: authGuard,
        },
        {
          path: "companies",
          children: [
            {
              path: "new",
              name: "new-company",
              component: NewCompanyView,
              beforeEnter: authGuard,
              meta: {
                breadcrumb: () => [
                  { label: "Clients", to: { name: "customers-overview" }, icon: "UsersIcon" },
                  { label: "Nouveau client" },
                ],
              },
            },
            {
              path: ":id",
              name: "company",
              component: CompanyView,
              beforeEnter: authGuard,
              meta: {
                breadcrumb: () => [
                  { label: "Clients", to: { name: "customers-overview" }, icon: "UsersIcon" },
                  { label: "Détail client" },
                ],
              },
            },
            {
              path: ":id/edit",
              name: "edit-company",
              component: EditCompanyView,
              beforeEnter: authGuard,
              meta: {
                breadcrumb: (route) => [
                  { label: "Clients", to: { name: "customers-overview" }, icon: "UsersIcon" },
                  {
                    label: "Détail client",
                    to: { name: "company", params: { id: route.params.id } },
                  },
                  { label: "Editer" },
                ],
              },
            },
          ],
        },
        {
          path: "physical-persons",
          children: [
            {
              path: ":id",
              name: "physical-person",
              component: PhysicalPersonView,
              beforeEnter: authGuard,
              meta: {
                breadcrumb: () => [
                  { label: "Clients", to: { name: "customers-overview" }, icon: "UsersIcon" },
                  { label: "Détail client" },
                ],
              },
            },
            {
              path: ":id/edit",
              name: "edit-physical-person",
              component: EditPhysicalPersonView,
              beforeEnter: authGuard,
              meta: {
                breadcrumb: (route) => [
                  { label: "Clients", to: { name: "customers-overview" }, icon: "UsersIcon" },
                  {
                    label: "Détail client",
                    to: { name: "physical-person", params: { id: route.params.id } },
                  },
                  { label: "Editer" },
                ],
              },
            },
            {
              path: "new",
              name: "new-physical-person",
              component: NewPhysicalPersonView,
              beforeEnter: authGuard,
              meta: {
                breadcrumb: () => [
                  { label: "Clients", to: { name: "customers-overview" }, icon: "UsersIcon" },
                  { label: "Nouveau client" },
                ],
              },
            },
          ],
        },
      ],
    },
    {
      path: "/sale-listing-agreements",
      meta: { breadcrumb: "Vente" },
      component: SaleListingAgreementsView,
      children: [
        {
          path: "",
          name: "sale-listing-agreements",
          component: SaleListingAgreementsOverviewView,
          beforeEnter: authGuard,
        },
        {
          path: "new",
          name: "new-sale-listing-agreement",
          component: NewSaleListingAgreement,
          beforeEnter: authGuard,
          meta: {
            breadcrumb: () => [
              {
                label: "Ventes",
                to: { name: "sale-listing-agreements" },
                icon: "DocumentTextIcon",
              },
              { label: "Nouvelle vente" },
            ],
          },
        },
        {
          path: ":id",
          children: [
            {
              path: "edit",
              name: "edit-sale-listing-agreement",
              component: EditSaleListingAgreement,
              beforeEnter: authGuard,
              meta: {
                breadcrumb: (route) => [
                  {
                    label: "Ventes",
                    to: { name: "sale-listing-agreements" },
                    icon: "DocumentTextIcon",
                  },
                  {
                    label: "Détail vente",
                    to: { name: "sale-listing-agreement", params: { id: route.params.id } },
                  },
                  { label: "Editer" },
                ],
              },
            },
          ],
        },
        {
          path: ":id",
          name: "sale-listing-agreement",
          component: SaleListingAgreementView,
          beforeEnter: authGuard,
          meta: {
            breadcrumb: () => [
              {
                label: "Ventes",
                to: { name: "sale-listing-agreements" },
                icon: "DocumentTextIcon",
              },
              { label: "Détail vente" },
            ],
          },
        },
        {
          path: ":id/risk-profile",
          name: "sale-listing-agreement-risk-profile",
          component: SaleListingAgreementRiskProfileView,
          beforeEnter: authGuard,
          meta: {
            breadcrumb: (route) => [
              {
                label: "Ventes",
                to: { name: "sale-listing-agreements" },
                icon: "DocumentTextIcon",
              },
              {
                label: "Détail vente",
                to: { name: "sale-listing-agreement", params: { id: route.params.id } },
              },
              { label: "Profil de risque" },
            ],
          },
        },
      ],
    },
    {
      path: "/rental-listing-agreements",
      meta: { breadcrumb: "Location" },
      component: RentalListingAgreementsView,
      children: [
        {
          path: "",
          name: "rental-listing-agreements",
          component: RentalListingAgreementsOverviewView,
          beforeEnter: authGuard,
        },
        {
          path: "new",
          name: "new-rental-listing-agreement",
          component: NewRentalListingAgreementView,
          beforeEnter: authGuard,
          meta: {
            breadcrumb: () => [
              {
                label: "Locations",
                to: { name: "rental-listing-agreements" },
                icon: "DocumentTextIcon",
              },
              { label: "Nouvelle location" },
            ],
          },
        },
        {
          path: ":id",
          children: [
            {
              path: "edit",
              name: "edit-rental-listing-agreement",
              component: EditRentalListingAgreementView,
              beforeEnter: authGuard,
              meta: {
                breadcrumb: (route) => [
                  {
                    label: "Locations",
                    to: { name: "rental-listing-agreements" },
                    icon: "DocumentTextIcon",
                  },
                  {
                    label: "Détail location",
                    to: { name: "rental-listing-agreement", params: { id: route.params.id } },
                  },
                  { label: "Editer" },
                ],
              },
            },
          ],
        },
        {
          path: ":id",
          name: "rental-listing-agreement",
          component: RentalListingAgreementView,
          beforeEnter: authGuard,
          meta: {
            breadcrumb: () => [
              {
                label: "Locations",
                to: { name: "rental-listing-agreements" },
                icon: "DocumentTextIcon",
              },
              { label: "Détail location" },
            ],
          },
        },
        {
          path: ":id/risk-profile",
          name: "rental-listing-agreement-risk-profile",
          component: RentalListingAgreementRiskProfileView,
          beforeEnter: authGuard,
          meta: {
            breadcrumb: (route) => [
              {
                label: "Locations",
                to: { name: "rental-listing-agreements" },
                icon: "DocumentTextIcon",
              },
              {
                label: "Détail location",
                to: { name: "rental-listing-agreement", params: { id: route.params.id } },
              },
              { label: "Profil de risque" },
            ],
          },
        },
      ],
    },
    {
      path: "/purchase-offers",
      meta: { breadcrumb: "Offre d'achat" },
      component: PurchaseOffersView,
      children: [
        {
          path: "new",
          name: "new-purchase-offer",
          component: NewPurchaseOfferView,
          beforeEnter: authGuard,
          meta: {
            breadcrumb: (route) => [
              {
                label: "Ventes",
                to: { name: "sale-listing-agreements" },
                icon: "DocumentTextIcon",
              },
              {
                label: "Détail vente",
                to: {
                  name: "sale-listing-agreement",
                  params: { id: route.query.saleListingAgreementId },
                },
              },
              { label: "Nouvelle offre d'achat" },
            ],
          },
        },
        {
          path: ":id",
          children: [
            {
              path: "edit",
              name: "edit-purchase-offer",
              component: EditPurchaseOfferView,
              beforeEnter: authGuard,
              meta: {
                breadcrumb: (route) => [
                  {
                    label: "Ventes",
                    to: { name: "sale-listing-agreements" },
                    icon: "DocumentTextIcon",
                  },
                  {
                    label: "Détail vente",
                    to: {
                      name: "sale-listing-agreement",
                      params: { id: route.query.saleListingAgreementId },
                    },
                  },
                  { label: "Editer l'offre d'achat" },
                ],
              },
            },
          ],
        },
      ],
    },
    {
      path: "/purchase-agreements",
      meta: { breadcrumb: "Compromis de vente" },
      component: PurchaseAgreementsView,
      children: [
        {
          path: "new",
          name: "new-purchase-agreement",
          component: NewPurchaseAgreementView,
          beforeEnter: authGuard,
          meta: {
            breadcrumb: (route) => [
              {
                label: "Ventes",
                to: { name: "sale-listing-agreements" },
                icon: "DocumentTextIcon",
              },
              {
                label: "Détail vente",
                to: {
                  name: "sale-listing-agreement",
                  params: { id: route.query.saleListingAgreementId },
                },
              },
              { label: "Nouveau compromis de vente" },
            ],
          },
        },
        {
          path: ":id",
          children: [
            {
              path: "edit",
              name: "edit-purchase-agreement",
              component: EditPurchaseAgreementView,
              beforeEnter: authGuard,
              meta: {
                breadcrumb: (route) => [
                  {
                    label: "Ventes",
                    to: { name: "sale-listing-agreements" },
                    icon: "DocumentTextIcon",
                  },
                  {
                    label: "Détail vente",
                    to: {
                      name: "sale-listing-agreement",
                      params: { id: route.query.saleListingAgreementId },
                    },
                  },
                  { label: "Editer un compromis de vente" },
                ],
              },
            },
          ],
        },
      ],
    },
    {
      path: "/lease-agreements",
      meta: { breadcrumb: "Bail" },
      component: LeaseAgreementsView,
      children: [
        {
          path: "new",
          name: "new-lease-agreement",
          component: NewLeaseAgreementView,
          beforeEnter: authGuard,
          meta: {
            breadcrumb: (route) => [
              {
                label: "Locations",
                to: { name: "rental-listing-agreements" },
                icon: "DocumentTextIcon",
              },
              {
                label: "Détail location",
                to: {
                  name: "rental-listing-agreement",
                  params: { id: route.query.rentalListingAgreementId },
                },
              },
              { label: "Nouveau bail" },
            ],
          },
        },
        {
          path: ":id",
          children: [
            {
              path: "edit",
              name: "edit-lease-agreement",
              component: EditLeaseAgreementView,
              beforeEnter: authGuard,
              meta: {
                breadcrumb: (route) => [
                  {
                    label: "Locations",
                    to: { name: "rental-listing-agreements" },
                    icon: "DocumentTextIcon",
                  },
                  {
                    label: "Détail location",
                    to: {
                      name: "rental-listing-agreement",
                      params: { id: route.query.rentalListingAgreementId },
                    },
                  },
                  { label: "Editer un bail" },
                ],
              },
            },
          ],
        },
      ],
    },
    {
      path: "/documents",
      name: "organization-documents",
      component: OrganizationDocumentsView,
      beforeEnter: authGuard,
      meta: { breadcrumb: "Documents" },
    },
    {
      path: "/countries-risk",
      name: "countries-risk",
      component: CountriesRiskView,
      beforeEnter: authGuard,
      meta: { breadcrumb: "Liste des pays" },
    },
    {
      path: "/settings",
      name: "settings",
      component: SettingsView,
      beforeEnter: authGuard,
      meta: { breadcrumb: "Paramètres" },
    },
    {
      path: "/callback",
      name: "callback",
      component: CallbackView,
    },
  ],
});

export default router;
